import { render } from "./UiLoader.vue?vue&type=template&id=5909c314"
const script = {}
script.render = render

export default script